export default __webpack_public_path__ + "static/media/CQ1.3c3bd5c6.png";